var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"flex items-center justify-center w-8 h-8 rounded-full hover:bg-gray-100 hover:text-gray-900 focus:outline-none focus-visible:outline-blue"},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }